const state = {
  balance: null,
  trcAddress: null,
  trcAddressValidTo: 0
};

const getters = {
  getUserBalance: state => {
    if (state.balance == null) {
      return localStorage.getItem("user_balance");
    }
    return state.balance;
  },
  getTRC20Address: state => {
    if (state.trcAddress == null || state.trcAddress == 0 || state.trcAddressValidTo == 0) { 
      return {
        address: localStorage.getItem("trc20addr"),
        validTo: localStorage.getItem("trc20addrValid")  
      }; 
    }
    return {
      address: state.trcAddress,
      validTo: state.trcAddressValidTo
    }; 
  },
  getERC20Address: state => {
    if (state.ercAddress == null || state.ercAddress == 0 || state.ercAddressValidTo == 0) { 
      return {
        address: localStorage.getItem("erc20addr"),
        validTo: localStorage.getItem("erc20addrValid")  
      }; 
    }
    return {
      address: state.ercAddress,
      validTo: state.ercAddressValidTo
    }; 
  }
};

const mutations = {
  changeUserBalance: (state, newItem) => {
    localStorage.setItem("user_balance", newItem);
    state.balance = newItem;
  },
  setNewTRC20Address: (state, address) => {
    localStorage.setItem("trc20addr", address.address);
    localStorage.setItem("trc20addrValid", address.validTo);
    state.trcAddress = address.address;
    state.trcAddressValidTo = address.validTo;
  },
  setNewERC20Address: (state, address) => {
    localStorage.setItem("erc20addr", address.address);
    localStorage.setItem("erc20addrValid", address.validTo);
    state.ercAddress = address.address;
    state.ercAddressValidTo = address.validTo;
  }
};

export default {
  state,
  getters,
  mutations
};


//////////////////
// WEBPACK FOOTER
// ./store/modules/user-details.js
// module id = null
// module chunks = 